// Vendors
import styled from 'styled-components';
const InputTooltipComponentStyled = styled.div `
  display: flex;
  justify-content: flex-start;
  margin-left: 4px; // TODO: Add to theme
  width: 100%;
`;
InputTooltipComponentStyled.displayName = 'InputTooltipComponentStyled';
export { InputTooltipComponentStyled };
//# sourceMappingURL=input-tooltip.component.styled.js.map